<template>
  <div v-if="type == 'text'">{{ formatter != null ? formatter(value) : value }}<slot></slot></div>
</template>

<script>
export default {
  name: 'ElDisplay',

  data () {
    return {
    }
  },

  props: {
    type: {
      default: 'text'
    },
    value: [String, Number, Object],
    formatter: Function
  },

  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Display.vue